import {
  ADD_FAVOURITE_PROJECT_PRIORITY,
  FETCH_PROJECT_PRIORITY,
  FETCH_PROJECT_PRIORITY_SUCCESS,
  FETCH_ALL_PROJECT_PRIORITY,
  FETCH_ALL_PROJECT_PRIORITY_SUCCESS,
  FILTER_PROJECT_PRIORITY,
  GET_ALL_PROJECT_PRIORITY,
  GET_UNSELECTED_ALL_PROJECT_PRIORITY,
  HANDLE_PROJECT_PRIORITY_REQUEST_CLOSE,
  HIDE_PROJECT_PRIORITY_LOADER,
  SHOW_PROJECT_PRIORITY_LOADER,
  ON_ADD_PROJECT_PRIORITY,
  ON_ALL_PROJECT_PRIORITY_SELECT,
  ON_PROJECT_PRIORITY_CLOSE,
  ON_PROJECT_PRIORITY_SELECT,
  ON_DELETE_PROJECT_PRIORITY,
  ON_DELETE_PROJECT_PRIORITY_SUCCESS,
  ON_DELETE_SELECTED_PROJECT_PRIORITY,
  ON_FILTER_PROJECT_PRIORITY_OPTION_SELECT,
  ON_SAVE_PROJECT_PRIORITY,
  ON_SAVE_PROJECT_PRIORITY_SUCCESS,
  ON_TOGGLE_PROJECT_PRIORITY_DRAWER,
  SHOW_PROJECT_PRIORITY_MESSAGE,
  UPDATE_SEARCH_PROJECT_PRIORITY,
  ON_UPDATE_PROJECT_PRIORITIES,
} from 'constants/ActionTypes';

export const onUpdateProjectPriorities = (payload) => {
  return {
      type: ON_UPDATE_PROJECT_PRIORITIES,
      payload
  };
};
export const fetchProjectPriority = (payload) => {
  return {
      type: FETCH_PROJECT_PRIORITY,
      payload
  };
};
export const fetchProjectPrioritySuccess = (payload) => {
  return {
      type: FETCH_PROJECT_PRIORITY_SUCCESS,
      payload
  };
};
export const fetchProjectPrioritys = () => {
  return {
      type: FETCH_ALL_PROJECT_PRIORITY
  };
};
export const fetchProjectPrioritysSuccess = (payload) => {
  return {
      type: FETCH_ALL_PROJECT_PRIORITY_SUCCESS,
      payload
  };
};
export const showProjectPriorityMessage = (message) => {
  return {
      type: SHOW_PROJECT_PRIORITY_MESSAGE,
      payload: message
  };
};
export const addFavouriteProjectPriority = (payload) => {
  return {
      type: ADD_FAVOURITE_PROJECT_PRIORITY,
      payload
  };
};
export const onProjectPrioritySelect = (payload) => {
  return {
      type: ON_PROJECT_PRIORITY_SELECT,
      payload
  };
};
export const onAddProjectPriority = () => {
  return {
      type: ON_ADD_PROJECT_PRIORITY,
      payload: ''
  };
};
export const onProjectPriorityClose = () => {
  return {
      type: ON_PROJECT_PRIORITY_CLOSE,
      payload: ''
  };
};
export const onFilterProjectPriorityOptionSelect = (payload) => {
  return {
      type: ON_FILTER_PROJECT_PRIORITY_OPTION_SELECT,
      payload
  };
};
export const onSaveProjectPriority = (payload) => {
  return {
      type: ON_SAVE_PROJECT_PRIORITY,
      payload
  };
};
export const onSaveProjectPrioritySuccess = (data) => {
  return {
      type: ON_SAVE_PROJECT_PRIORITY_SUCCESS,
      payload: data
  };
};
export const onDeleteProjectPriority = (payload) => {
  return {
      type: ON_DELETE_PROJECT_PRIORITY,
      payload
  };
};
export const onDeleteProjectPrioritySuccess = (payload) => {
  return {
      type: ON_DELETE_PROJECT_PRIORITY_SUCCESS,
      payload
  };
};
export const onDeleteSelectedProjectPriority = () => {
  return {
      type: ON_DELETE_SELECTED_PROJECT_PRIORITY,
      payload: ''
  };
};
export const filterProjectPriority = (payload) => {
  return {
      type: FILTER_PROJECT_PRIORITY,
      payload
  };
};
export const getAllProjectPriority = () => {
  return {
      type: GET_ALL_PROJECT_PRIORITY,
      payload: ''
  };
};
export const getUnselectedAllProjectPriority = () => {
  return {
      type: GET_UNSELECTED_ALL_PROJECT_PRIORITY,
      payload: ''
  };
};
export const onAllProjectPrioritySelect = () => {
  return {
      type: ON_ALL_PROJECT_PRIORITY_SELECT,
      payload: ''
  };
};
export const updateSearchProjectPriority = (payload) => {
  return {
      type: UPDATE_SEARCH_PROJECT_PRIORITY,
      payload
  };
};
export const onToggleProjectPriorityDrawer = () => {
  return {
      type: ON_TOGGLE_PROJECT_PRIORITY_DRAWER,
  };
};
export const handleProjectPriorityRequestClose = () => {
  return {
      type: HANDLE_PROJECT_PRIORITY_REQUEST_CLOSE,
  };
};
export const showProjectPriorityLoader = () => {
  return {
      type: SHOW_PROJECT_PRIORITY_LOADER,
  };
};
export const hideProjectPriorityLoader = () => {
  return {
      type: HIDE_PROJECT_PRIORITY_LOADER,
  };
};



// WEBPACK FOOTER //
// ./actions/projectPriority.js